import { render } from "./date-selector.vue?vue&type=template&id=6a479bb2"
import script from "./date-selector.vue?vue&type=script&lang=js"
export * from "./date-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__